import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import fetchAPI from '../../common/fetchAPI';
import { RootState } from '../../app/store';
import { sortData } from '../../common/timeLiveFunction';
import { TasksStateClass } from './interfaces/TasksStateClass';

const initialState: TasksStateClass = {
    status: 'idle',
    isLoading: true,
    isLoadingSummary: false,
    isReload: false,
    accountProjectId: 0,
    accountProjectTaskId: 0,
    projectTaskList: [],
    timeEntryFormat: 'Time',
    //
    taskTeamList: [],
    addTaskTeamList: [],
    selectedTaskTeamList: [],
    deletedTaskTeamList: [],
    //
    remainderTeamList: [],
    addRemainderTaskTeamList: [],
    selectRemainderTaskTeamList: [],
    deletedRemainderTaskTeamList: [],
    //pagination Start
    startRec: 0,
    search: '',
    pageNo: 1,
    pageSize: 10,
    totalItems: 0,
    recordsFiltered: 0,
    isSearch: false,
    sortOrder: 'asc',
    sortColumn: 'Orig_TaskName',
    //pagination End
    isLoadTaskFields: false,
    searchTaskList: [],
    searchRemainderTeamList: [],
    isParentTask: false,
    nextPage: false,
    isReloadFromMoveTask: false,
    isMoveTask: false,
    isTaskReload: false
}

interface IThunkApi {
    state: {
        tasks: TasksStateClass;
    }
}

export const getProjectTaskList = createAsyncThunk
    <any, void, IThunkApi>
    (
        'Task/getProjectTaskList',
        async (arg, thunkApi) => {
            const { accountProjectId, startRec, search, pageNo, pageSize } = thunkApi.getState().tasks;
            const response = await fetchAPI(`api/Tasks/GetAccountProjectTaskForReactTable/${accountProjectId}/${startRec}/${pageSize}/${pageNo}/${search}`, `Get`, '', true);
            const json = await response.json();
            return json;
        }
    )

export const getProjectTaskTeam = createAsyncThunk
    <any, void, IThunkApi>
    (
        'Task/getProjectTaskTeam',
        async (arg, thunkApi) => {
            const { accountProjectId, accountProjectTaskId } = thunkApi.getState().tasks;
            const response = await fetchAPI(`api/Tasks/GetTaskTeamMembers/${accountProjectId}/${accountProjectTaskId}`, `Get`, '', true);
            const json = await response.json();
            return json;
        }
    )

export const getTaskTeamReminder = createAsyncThunk
    <any, void, IThunkApi>
    (
        'Task/getTaskTeamReminder',
        async (arg, thunkApi) => {
            const { accountProjectId, accountProjectTaskId } = thunkApi.getState().tasks;
            const response = await fetchAPI(`api/Tasks/GetTaskTeamReminder/${accountProjectId}/${accountProjectTaskId}`, `Get`, '', true);
            const json = await response.json();
            return json;
        }
    )

export const addAccountProjectTask = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Task/addAccountProjectTask',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/Tasks/AddTaskRecord', 'POST', arg, true);
            const json = await response.json();
            return json;
        }
    )

export const updateAccountProjectTask = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Task/updateAccountProjectTask',
        async (arg, thunkApi) => {
            const { accountProjectTaskId } = thunkApi.getState().tasks;
            const response = await fetchAPI(`api/Tasks/UpdateTaskRecord/${accountProjectTaskId}`, 'POST', arg, true);
            const json = await response.json();
            return json;
        }
    )

export const updateAccountProjectTaskStatus = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Task/updateAccountProjectTaskStatus',
        async (arg, thunkApi) => {
            let { IsDisabled, AccountProjectTaskId } = arg
            const response = await fetchAPI(`api/Tasks/UpdateAccountProjectTaskStatus/${IsDisabled}/${AccountProjectTaskId}`, 'POST', true);
            const json = await response.json();
            return json;
        }
    )

export const deleteSelectedAccountProjectTasks = createAsyncThunk
    <any, any, IThunkApi>
    (
        "Task/deleteSelectedAccountProjectTasks",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/Tasks/RemoveAccountProjectTasks/', 'Delete', arg, true);
            const json = await response.json();
            return json;
        }
    )

export const deleteAccountProjectTask = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Task/deleteAccountProjectTask',
        async (arg, thunkApi) => {
            const response = await fetchAPI(`api/Tasks/${Number(arg)}`, `Delete`, '', true);
            const json = await response.json();
            return json;
        }
    )

const sortHierarchicalData = (data: any[], sortOrder: string, sortColumn: string) => {
  const blocks: { parent: any, children: any[], effectiveValue: any }[] = [];
  let currentBlock: { parent: any, children: any[], effectiveValue: any } | null = null;

  data.forEach(item => {
    if (item.Level === 0) {
      if (currentBlock) blocks.push(currentBlock);
      currentBlock = { parent: { ...item }, children: [], effectiveValue: item[sortColumn] };
    } else {
      if (currentBlock) {
        currentBlock.children.push({ ...item });
      } else {
        blocks.push({ parent: { ...item }, children: [], effectiveValue: item[sortColumn] });
      }
    }
  });
  if (currentBlock) blocks.push(currentBlock);

  blocks.forEach(block => {
    if (block.children.length > 0 && (sortColumn === 'RawLastUpdated' || sortColumn === 'LastUpdated')) {

      block.children.sort((a, b) => {
        let aVal = a[sortColumn];
        let bVal = b[sortColumn];
        if (aVal === bVal) return 0;
        if (!aVal) return 1;
        if (!bVal) return -1;
        return sortOrder === 'asc' ? (aVal > bVal ? 1 : -1) : (aVal < bVal ? 1 : -1);
      });

      
      let latestChild = block.children[0];
      if (sortOrder === 'desc') {
        if (latestChild[sortColumn] > block.parent[sortColumn]) {
          block.parent.LastUpdated = latestChild.LastUpdated;
          block.parent.RawLastUpdated = latestChild.RawLastUpdated;
          block.effectiveValue = latestChild[sortColumn];
        }
      }
    }

    block.effectiveValue = block.parent[sortColumn];
  });

  blocks.sort((a, b) => {
    let aVal = a.effectiveValue;
    let bVal = b.effectiveValue;

    if (aVal === bVal) return 0;
    if (aVal === null || aVal === undefined) return 1;
    if (bVal === null || bVal === undefined) return -1;

    if (sortOrder === 'asc') {
      return aVal > bVal ? 1 : -1;
    } else {
      return aVal < bVal ? 1 : -1;
    }
  });

  const sortedArray: any[] = [];
  blocks.forEach(block => {
    sortedArray.push(block.parent);
    sortedArray.push(...block.children);
  });

  return sortedArray;
};

export const tasksSlice = createSlice({
    name: 'tasks',
    initialState,
    reducers: {
        updateIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        updateIsLoadingSummary: (state, action: PayloadAction<boolean>) => {
            state.isLoadingSummary = action.payload;
        },
        updateAccountProjectId: (state, action: PayloadAction<any>) => {
            state.accountProjectId = action.payload;
        },
        updateAccountProjectTaskId: (state, action: PayloadAction<any>) => {
            console.log('updateAccountProjectTaskId :',action.payload)
            state.accountProjectTaskId = action.payload;
            state.isLoadTaskFields = true;
        },
        updateAccountProjectTaskIdFromList: (state, action: PayloadAction<any>) => {
            console.log('updateAccountProjectTaskIdFromList :',action.payload)
            state.accountProjectTaskId = action.payload;
        },
        updateIsLoadTaskFields: (state, action: PayloadAction<any>) => {
            state.isLoadTaskFields = action.payload;
        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.startRec = action.payload.startRec;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSearchPagination: (state, action: PayloadAction<any>) => {
            state.isSearch = state.isSearch ? false : true;
            state.search = action.payload;
        },
        // updateSorting: (state, action: PayloadAction<any>) => {
        //     state.sortOrder = action.payload.sortOrder;
        //     state.sortColumn = action.payload.sortColumn;
        //     let tempArray = state.projectTaskList;
        //     state.projectTaskList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        // },
        updateSorting: (state, action: PayloadAction<any>) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            let tempArray = [...state.projectTaskList];
            state.projectTaskList = sortHierarchicalData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        },
        checkedAllState: (state) => {
            const newArray = state.projectTaskList.map((item) => ({
                ...item,
                isSelected: 1
            }));
            state.projectTaskList = newArray;
        },
        unCheckedAllState: (state) => {
            const newArray = state.projectTaskList.map((item) => ({
                ...item,
                isSelected: 0
            }));
            state.projectTaskList = newArray;
        },
        checkedState: (state, action) => {
            const currentindex = state.projectTaskList.findIndex((item) => item.AccountProjectTaskId == action.payload);
            const newArray = [...state.projectTaskList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.projectTaskList = newArray;
        },
        unCheckedState: (state, action) => {
            const currentindex = state.projectTaskList.findIndex((item) => item.AccountProjectTaskId == action.payload);
            const newArray = [...state.projectTaskList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.projectTaskList = newArray;
        },
        // updateSelectedResource: (state, action: PayloadAction<any>) => {
        //     const index = state.taskTeamList.findIndex((item) => item.Id === action.payload);
        //     if (state.accountProjectTaskId != 0) {
        //         let selectedTaskTeamListIndexs = state.selectedTaskTeamList.findIndex((item) => item.Id === action.payload);
        //         let addTeamlistIndexs = state.addTaskTeamList.findIndex((item) => item.Id === action.payload);
        //         let deletedTaskTeamListIndex = state.deletedTaskTeamList.findIndex((item) => item.Id === action.payload);
        //         var obj = state.taskTeamList[index];
        //         var objSearch = state.searchTaskList[index];
        //         if (selectedTaskTeamListIndexs == -1 && addTeamlistIndexs == -1 && deletedTaskTeamListIndex == -1) {
        //             obj.IncludeTeam = 1;
        //             objSearch.IncludeTeam = 1;
        //             state.addTaskTeamList.push(state.taskTeamList[index]);
        //         }
        //         if (selectedTaskTeamListIndexs == -1 && deletedTaskTeamListIndex != -1) {
        //             obj.IncludeTeam = 1;
        //             objSearch.IncludeTeam = 1;
        //             state.selectedTaskTeamList.push(state.deletedTaskTeamList[deletedTaskTeamListIndex]);
        //             state.deletedTaskTeamList.splice(state.deletedTaskTeamList.findIndex((item) => item.Id === action.payload), 1);
        //         }
        //     } else {
        //         const newArray = [...state.taskTeamList];
        //         newArray[index] = { ...newArray[index], IncludeTeam: 1 };
        //         state.taskTeamList = newArray;
        //         state.searchTaskList = newArray;
        //     }
        // },
        updateSelectedResource: (state, action: PayloadAction<number>) => {
            const { payload: selectedId } = action;        
            const index = state.taskTeamList.findIndex((item) => item.Id === selectedId);
            if (index === -1) return; 
        
            const obj = { ...state.taskTeamList[index] }; 
        
            obj.IncludeTeam = obj.IncludeTeam === 1 ? 0 : 1;
        
            state.taskTeamList = state.taskTeamList.map((item) =>
                item.Id === selectedId ? { ...item, IncludeTeam: obj.IncludeTeam } : item
            );
            if (obj.IncludeTeam === 1) {
                if (!state.addTaskTeamList.find((item) => item.Id === selectedId)) {
                    state.addTaskTeamList.push(obj);
                }
            } else {
                state.addTaskTeamList = state.addTaskTeamList.filter((item) => item.Id !== selectedId);
            }
        },
        
        
        updateUnSelectedResource: (state, action: PayloadAction<any>) => {
            const index = state.taskTeamList.findIndex((item) => item.Id === action.payload);
            if (state.accountProjectTaskId != 0) {
                let selectedTaskTeamListIndexs = state.selectedTaskTeamList.findIndex((item) => item.Id === action.payload);
                let addTeamlistIndexs = state.addTaskTeamList.findIndex((item) => item.Id === action.payload);
                let deletedTeamIndex = state.deletedTaskTeamList.findIndex((item) => item.Id === action.payload);
                var obj = state.taskTeamList[index];
                var objSearch = state.searchTaskList[index];
                if (addTeamlistIndexs != -1) {
                    obj.IncludeTeam = 0;
                    objSearch.IncludeTeam = 0;
                    state.addTaskTeamList.splice(state.addTaskTeamList.findIndex((item) => item.Id === action.payload), 1);
                }
                if (selectedTaskTeamListIndexs == -1 && addTeamlistIndexs == -1) {
                    obj.IncludeTeam = 0;
                    objSearch.IncludeTeam = 0;
                    state.deletedTaskTeamList.push(state.taskTeamList[index]);
                    state.selectedTaskTeamList.splice(state.selectedTaskTeamList.findIndex((item) => item.Id === action.payload), 1);
                }
                if (selectedTaskTeamListIndexs != -1 && deletedTeamIndex == -1) {
                    obj.IncludeTeam = 0;
                    objSearch.IncludeTeam = 0;
                    state.deletedTaskTeamList.push(state.selectedTaskTeamList[selectedTaskTeamListIndexs]);
                    state.selectedTaskTeamList.splice(state.selectedTaskTeamList.findIndex((item) => item.Id === action.payload), 1);
                }
            } else {
                const newArray = [...state.taskTeamList];
                newArray[index] = { ...newArray[index], IncludeTeam: 0 };
                state.taskTeamList = newArray;
                state.searchTaskList = newArray;
            }
        },
        updateAllSelectedAndUnSelected: (state, action: PayloadAction<any>) => {        
            state.addTaskTeamList = [];
            state.taskTeamList = action.payload;
            state.searchTaskList = action.payload;            
        },
        selectedAndUnSelectedOnEditMode: (state, action: PayloadAction<any>) => {
            state.taskTeamList.map((item) => {
                if (action.payload) {
                    let deletedTaskTeamListIndex = state.deletedTaskTeamList.findIndex(x => x.Id == item.Id);
                    let addTeamlistIndexs = state.addTaskTeamList.findIndex((x) => x.Id === item.Id);
                    let selectedTeamListIndex = state.selectedTaskTeamList.findIndex((x) => x.Id === item.Id);
                    if (selectedTeamListIndex == -1 && addTeamlistIndexs == -1 && deletedTaskTeamListIndex == -1) {
                        if (item.IncludeTeam == 0) {
                            item.IncludeTeam = 1;
                            state.addTaskTeamList.push(item);
                        } else {
                            state.selectedTaskTeamList.push(item);
                        }
                    }
                    if (deletedTaskTeamListIndex != -1) {
                        item.IncludeTeam = 1;
                        state.selectedTaskTeamList.push(state.deletedTaskTeamList[deletedTaskTeamListIndex]);
                        state.deletedTaskTeamList.splice(state.deletedTaskTeamList.findIndex((deleteItem) => deleteItem.Id === item.Id), 1);
                    }
                    if (selectedTeamListIndex != -1) {
                        item.IncludeTeam = 1;
                        if (state.addTaskTeamList.findIndex(x => x.Id == item.Id) == -1) {
                            state.addTaskTeamList.push(item);
                        }
                    }
                } else {
                    item.IncludeTeam = 0;
                    let selectedTaskTeamListIndex = state.selectedTaskTeamList.findIndex(x => x.Id == item.Id);
                    if (selectedTaskTeamListIndex != -1) {
                        state.deletedTaskTeamList.push(state.selectedTaskTeamList[selectedTaskTeamListIndex]);
                        state.selectedTaskTeamList.splice(state.selectedTaskTeamList.findIndex(x => x.Id == item.Id), 1);
                    }
                    state.addTaskTeamList.splice(state.addTaskTeamList.findIndex(x => x.Id == item.Id), 1);
                }
            });
            state.searchTaskList = state.taskTeamList;
        },
        updateSelectedRemainderTeam: (state, action: PayloadAction<any>) => {
            const index = state.remainderTeamList.findIndex((item) => item.Id === action.payload);
            if (state.accountProjectTaskId != 0) {
                let selectedTaskTeamListIndexs = state.selectRemainderTaskTeamList.findIndex((item) => item.Id === action.payload);
                let addTeamlistIndexs = state.addRemainderTaskTeamList.findIndex((item) => item.Id === action.payload);
                let deletedTaskTeamListIndex = state.deletedRemainderTaskTeamList.findIndex((item) => item.Id === action.payload);
                var obj = state.remainderTeamList[index];
                var objSearch = state.searchRemainderTeamList[index];
                if (selectedTaskTeamListIndexs == -1 && addTeamlistIndexs == -1 && deletedTaskTeamListIndex == -1) {
                    obj.IncludeTeam = 1;
                    objSearch.IncludeTeam = 1;
                    state.addRemainderTaskTeamList.push(state.remainderTeamList[index]);
                }
                if (selectedTaskTeamListIndexs == -1 && deletedTaskTeamListIndex != -1) {
                    obj.IncludeTeam = 1;
                    objSearch.IncludeTeam = 1;
                    state.selectRemainderTaskTeamList.push(state.deletedRemainderTaskTeamList[deletedTaskTeamListIndex]);
                    state.deletedRemainderTaskTeamList.splice(state.deletedRemainderTaskTeamList.findIndex((item) => item.Id === action.payload), 1);
                }
            } else {
                const newArray = [...state.remainderTeamList];
                newArray[index] = { ...newArray[index], IncludeTeam: 1 };
                state.remainderTeamList = newArray;
                state.searchRemainderTeamList = newArray;
            }
        },
        updateUnSelectedRemainderTeam: (state, action: PayloadAction<any>) => {
            const index = state.remainderTeamList.findIndex((item) => item.Id === action.payload);
            if (state.accountProjectTaskId != 0) {
                let selectedTaskTeamListIndexs = state.selectRemainderTaskTeamList.findIndex((item) => item.Id === action.payload);
                let addTeamlistIndexs = state.addRemainderTaskTeamList.findIndex((item) => item.Id === action.payload);
                let deletedTeamIndex = state.deletedRemainderTaskTeamList.findIndex((item) => item.Id === action.payload);
                var obj = state.remainderTeamList[index];
                var objSearch = state.searchRemainderTeamList[index];
                if (addTeamlistIndexs != -1) {
                    obj.IncludeTeam = 0;
                    objSearch.IncludeTeam = 0;
                    state.addRemainderTaskTeamList.splice(state.addRemainderTaskTeamList.findIndex((item) => item.Id === action.payload), 1);
                }
                if (selectedTaskTeamListIndexs == -1 && addTeamlistIndexs == -1) {
                    obj.IncludeTeam = 0;
                    objSearch.IncludeTeam = 0;
                    state.deletedRemainderTaskTeamList.push(state.remainderTeamList[index]);
                    state.selectRemainderTaskTeamList.splice(state.selectRemainderTaskTeamList.findIndex((item) => item.Id === action.payload), 1);
                }
                if (selectedTaskTeamListIndexs != -1 && deletedTeamIndex == -1) {
                    obj.IncludeTeam = 0;
                    objSearch.IncludeTeam = 0;
                    state.deletedRemainderTaskTeamList.push(state.selectRemainderTaskTeamList[selectedTaskTeamListIndexs]);
                    state.selectRemainderTaskTeamList.splice(state.selectRemainderTaskTeamList.findIndex((item) => item.Id === action.payload), 1);
                }
            } else {
                const newArray = [...state.remainderTeamList];
                newArray[index] = { ...newArray[index], IncludeTeam: 0 };
                state.remainderTeamList = newArray;
                state.searchRemainderTeamList = newArray;
            }
        },
        updateSelectUnSelectRemainderTeam: (state, action: PayloadAction<any>) => {
            state.remainderTeamList = action.payload;
            state.searchRemainderTeamList = action.payload;
        },
        updateNextPage: (state, action: PayloadAction<any>) => {
            state.nextPage = action.payload;
        },
        selectUnSelectRemainderTeamOnEditMode: (state, action: PayloadAction<any>) => {
            state.remainderTeamList.map((item) => {
                if (action.payload) {
                    let deletedTaskTeamListIndex = state.deletedRemainderTaskTeamList.findIndex(x => x.Id == item.Id);
                    let addTeamlistIndexs = state.addRemainderTaskTeamList.findIndex((x) => x.Id === item.Id);
                    let selectedTeamListIndex = state.selectRemainderTaskTeamList.findIndex((x) => x.Id === item.Id);
                    if (selectedTeamListIndex == -1 && addTeamlistIndexs == -1 && deletedTaskTeamListIndex == -1) {
                        if (item.IncludeTeam == 0) {
                            item.IncludeTeam = 1;
                            state.addRemainderTaskTeamList.push(item);
                        } else {
                            state.selectRemainderTaskTeamList.push(item);
                        }
                    }
                    if (deletedTaskTeamListIndex != -1) {
                        item.IncludeTeam = 1;
                        state.selectRemainderTaskTeamList.push(state.deletedRemainderTaskTeamList[deletedTaskTeamListIndex]);
                        state.deletedRemainderTaskTeamList.splice(state.deletedRemainderTaskTeamList.findIndex((deleteItem) => deleteItem.Id === item.Id), 1);
                    }
                    if (selectedTeamListIndex != -1) {
                        item.IncludeTeam = 1;
                        if (state.addRemainderTaskTeamList.findIndex(x => x.Id == item.Id) == -1) {
                            state.addRemainderTaskTeamList.push(item);
                        }
                    }
                } else {
                    item.IncludeTeam = 0;
                    let selectedTaskTeamListIndex = state.selectRemainderTaskTeamList.findIndex(x => x.Id == item.Id);
                    if (selectedTaskTeamListIndex != -1) {
                        state.deletedRemainderTaskTeamList.push(state.selectRemainderTaskTeamList[selectedTaskTeamListIndex]);
                        state.selectRemainderTaskTeamList.splice(state.selectRemainderTaskTeamList.findIndex(x => x.Id == item.Id), 1);
                    }
                    state.addRemainderTaskTeamList.splice(state.addRemainderTaskTeamList.findIndex(x => x.Id == item.Id), 1);
                }
            });
            state.searchRemainderTeamList = state.remainderTeamList;
        },


        // searchProjectTaskTeam: (state, action: PayloadAction<any>) => {
        //     const query = action.payload.toLowerCase();
        //     var searchData = state.searchTaskList.filter(
        //         x => x.Name && x.Name.toLowerCase().indexOf(query) > -1
        //     );
        //     state.taskTeamList = searchData;
        // },

        searchProjectTaskTeam: (state, action: PayloadAction<any>) => {
            const query = action.payload.toLowerCase();
                if (query.trim() === '') {             
                state.taskTeamList = state.searchTaskList.map((item) => {
                    const isSelected = state.addTaskTeamList.some((x) => x.Id === item.Id);
                    return { ...item, IncludeTeam: isSelected ? 1 : item.IncludeTeam };
                });
            } else {               
                state.taskTeamList = state.searchTaskList
                    .filter((x) => x.Name && x.Name.toLowerCase().includes(query))
                    .map((item) => {
                        const isSelected = state.addTaskTeamList.some((x) => x.Id === item.Id);                       
                        return { ...item, IncludeTeam: isSelected ? 1 : item.IncludeTeam };
                    });
            }
        },
        
        
        
        


        searchTaskRemainderTeam: (state, action: PayloadAction<any>) => {
            const query = action.payload.toLowerCase();
            var searchData = state.searchRemainderTeamList.filter(
                x => x.Name && x.Name.toLowerCase().indexOf(query) > -1
            );
            state.remainderTeamList = searchData;
        },
        resetProjectTaskTeam: (state) => {
            state.taskTeamList = [];
            state.addTaskTeamList = [];
            state.selectedTaskTeamList = [];
            state.deletedTaskTeamList = [];
            state.remainderTeamList = [];
            state.addRemainderTaskTeamList = [];
            state.selectRemainderTaskTeamList = [];
            state.deletedRemainderTaskTeamList = [];
            state.searchTaskList = [];
            state.searchRemainderTeamList = [];
        },
        reloadProjectTaskSummary: (state, action: PayloadAction<boolean>)=>{
            state.isReload = state.isReload ? false : true;
            state.isMoveTask = false;
            state.isTaskReload = false;
            // state.isMoveTask = true;
        },
        reloadFromMoveTask: (state) =>{
            state.isReloadFromMoveTask = state.isReloadFromMoveTask ? false : true;
        },
        updateLoadingState: (state, action) =>{
            state.isTaskReload = action.payload;
        },
        reloadProjectSummaryTab: (state) => {
            state.isReload = state.isReload ? false : true;
            state.isMoveTask = false;
            state.isTaskReload = false; 
        },
    
    },
    extraReducers: (builder) => {
        builder
            .addCase(getProjectTaskList.pending, (state) => {
                state.status = 'loading';
                state.projectTaskList = [];
                state.isLoading = true; 
            })
            .addCase(getProjectTaskList.fulfilled, (state, action) => {
                let TaskList = JSON.parse(action.payload.data);
                console.log('GetAccountProjectTaskForReactTable', JSON.parse(action.payload.data))
                if (TaskList.length > 0) {
                    TaskList.map((item: any) => {
                        item.isSelected = 0;
                        // delete item.Completed;
                        delete item.CompletedPercent;
                        /* delete item.Level; */
                        delete item.StartDate;
                        delete item.TaskName;
                        delete item.TaskStatusId;

                        // Normalize isParentTask based on IsParentTask
                        item.isParentTask = item.IsParentTask === true;
                        //item.isParentTask = item.isParentTask === true || item.isParentTask === "true" || item.isParentTask === 1;

                    });
                }

                // Check if any task is a parent task
                // Check if any task is a parent task
                state.isParentTask = TaskList.some((task: any) => {
                    // Convert possible string values to boolean

                    return task.isParentTask === true || task.isParentTask === "true" || task.isParentTask === 1;
                });

                if (state.isParentTask === true) {
                    state.projectTaskList = TaskList;
                } else {
                    state.projectTaskList = sortData(TaskList, state.sortOrder, state.sortColumn);
                }


                state.pageNo = action.payload.currentPage;
                state.startRec = action.payload.start;
                state.totalItems = action.payload.recordsTotal;
                state.search = action.payload.searchText;
                state.recordsFiltered = action.payload.recordsFiltered;
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(getProjectTaskList.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            //
            .addCase(getProjectTaskTeam.pending, (state) => {
                state.status = 'loading';
            })
            // .addCase(getProjectTaskTeam.fulfilled, (state, { payload }) => {
            //     state.status = 'idle';
            //     if (state.accountProjectTaskId === 0) {
            //         payload.map((item: any) => {
            //             item.IncludeTeam = 0;
            //         });
            //     }
            //     state.taskTeamList = payload;
            //     state.remainderTeamList = payload;
            //     payload.map((item: any) => {
            //         if (item.IncludeTeam == 1) {
            //             state.selectedTaskTeamList.push(item);
            //         }
            //     });
            //     state.searchTaskList = payload;
            //     state.searchRemainderTeamList = payload;
            // })
            .addCase(getProjectTaskTeam.fulfilled, (state, { payload }) => {
                state.status = 'idle';

                const data = (Array.isArray(payload) && !payload[0]?.Message) ? payload : [];

                if (state.accountProjectTaskId === 0) {
                    data.forEach((item: any) => { item.IncludeTeam = 0; });
                }

                state.taskTeamList = data;
                state.remainderTeamList = data;
                state.searchTaskList = data;
                state.searchRemainderTeamList = data;

                state.selectedTaskTeamList = []; 
                data.forEach((item: any) => {
                    if (item.IncludeTeam == 1) {
                        state.selectedTaskTeamList.push(item);
                    }
                });
            })
            .addCase(getProjectTaskTeam.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(getTaskTeamReminder.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getTaskTeamReminder.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.remainderTeamList.map((item: any) => {
                    if (payload.filter((x: any) => x.AccountEmployeeId == item.Id).length > 0) {
                        item.IncludeTeam = 1;
                        state.selectRemainderTaskTeamList.push(item);
                    } else {
                        item.IncludeTeam = 0;
                    }
                });
            })
            .addCase(getTaskTeamReminder.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(addAccountProjectTask.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(addAccountProjectTask.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isReload = state.isReload ? false : true;
                state.isLoading = false;
                state.isTaskReload = true;
            })
            .addCase(addAccountProjectTask.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(updateAccountProjectTask.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateAccountProjectTask.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isReload = state.isReload ? false : true;
                state.isLoading = false;
                state.isTaskReload = true;
            })
            .addCase(updateAccountProjectTask.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(updateAccountProjectTaskStatus.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(updateAccountProjectTaskStatus.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (Number(payload.id) > 0) {
                    state.projectTaskList.map((item: any) => {
                        if (item.AccountProjectTaskId == Number(payload.id)) {
                            item.IsDisabled = item.IsDisabled ? false : true;
                        }
                    })
                }
                state.isLoading = false;
            })
            .addCase(updateAccountProjectTaskStatus.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(deleteSelectedAccountProjectTasks.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteSelectedAccountProjectTasks.fulfilled, (state, action) => {
                state.status = 'idle';
                state.isReload = state.isReload ? false : true;
                state.isLoading = false;
            })
            .addCase(deleteSelectedAccountProjectTasks.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(deleteAccountProjectTask.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(deleteAccountProjectTask.fulfilled, (state, action) => {
                state.projectTaskList = state.projectTaskList.filter(x => x.AccountProjectTaskId != action.payload.id);
                state.status = 'idle';
                state.isLoading = false;
            })
            .addCase(deleteAccountProjectTask.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
    }
})
export const {
    updateIsLoading, updateAccountProjectId, updateAccountProjectTaskId, updateSearchPagination, updatePagination, checkedAllState, unCheckedAllState, checkedState, unCheckedState,
    updateSelectedResource, updateUnSelectedResource, updateAllSelectedAndUnSelected, selectedAndUnSelectedOnEditMode,
    updateSelectedRemainderTeam, updateUnSelectedRemainderTeam, updateSelectUnSelectRemainderTeam, selectUnSelectRemainderTeamOnEditMode, updateIsLoadingSummary, updateIsLoadTaskFields,
    searchProjectTaskTeam, searchTaskRemainderTeam, resetProjectTaskTeam, updateSorting, updateNextPage, reloadProjectTaskSummary, reloadFromMoveTask, updateLoadingState,reloadProjectSummaryTab,
    updateAccountProjectTaskIdFromList
} = tasksSlice.actions

export const TasksState = (state: RootState) => state.tasks
export default tasksSlice.reducer